
/**
 * Re-order group Keys based on the desired position change
 * @param groupKeysArray - An array of groupKeys.
 * @param groupKey - String which needs to be moved.
 * @param positionChange - Number of positions that needs to be moved.
 * @returns newgroupKeysArray - New re-arranged groupKeys
 */

export function moveGroupKeyInArray(groupKeysArray, groupKey, positionChange) {
    const oldIndex = groupKeysArray.indexOf(groupKey);
    if (oldIndex > -1) {
        let newIndex = (oldIndex + positionChange);

        if (newIndex < 0) {
            newIndex = 0;
        } else if (newIndex >= groupKeysArray.length) {
            newIndex = groupKeysArray.length;
        }

        const newgroupKeysArray = groupKeysArray.slice();
        newgroupKeysArray.splice(oldIndex, 1);
        newgroupKeysArray.splice(newIndex, 0, groupKey);

        return newgroupKeysArray;
    }
    return groupKeysArray;
}

export function getDefaultGroupData(groupData, defaultGroupKey) {
    const defaultGroupData = groupData && groupData.find((element) => {
        return element.groupKey === defaultGroupKey;
    });
    return defaultGroupData ? [defaultGroupData] : [];
}

export function getGroupDataWithoutDefaultGroup(groupData, defaultGroupKey) {
    return groupData && groupData.filter((element) => {
        return element.groupKey !== defaultGroupKey;
    }) || [];
}

export function getAllGroupKeys(channel) {
    const allGroupKeys = channel && channel.groupKeys ? channel.groupKeys.slice() : [];
    if (channel && channel.defaultGroupKey) {
        allGroupKeys.push(channel.defaultGroupKey);
    }
    return allGroupKeys;
}



// WEBPACK FOOTER //
// ./src/app-lib/helpers/groups-helper.js